import { Injectable } from '@angular/core';

import { SelvedgeColour } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SelvedgeColourService extends TmsWebBaseEditService<SelvedgeColour, SelvedgeColour> {
  constructor() {
    super('SelvedgeColour', $localize`Selvedge Colour`);
  }
}
